export const capitalizeFirstLetter = (str: string): string => {
	return str.charAt(0).toUpperCase() + str.slice(1);
};

export const capitalizeWordWithExceptions = (str: string): string => {
	const exceptions = [
		'of',
		'or',
		'and',
		'the',
		'in',
		'on',
		'at',
		'to',
		'for',
		'with',
	];

	return str
		.split(' ')
		.map((word) =>
			exceptions.includes(word)
				? word
				: word.charAt(0).toUpperCase() + word.slice(1)
		)
		.join(' ');
};
